import { render, staticRenderFns } from "./AboutMentes.vue?vue&type=template&id=27a08886&scoped=true&"
import script from "./AboutMentes.vue?vue&type=script&lang=js&"
export * from "./AboutMentes.vue?vue&type=script&lang=js&"
import style0 from "./AboutMentes.vue?vue&type=style&index=0&id=27a08886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a08886",
  null
  
)

export default component.exports